import React, { useEffect, useState } from 'react'
import '../style/admin.css'
import Sidebar from './partial/Sidebar'
import Header from './partial/Header'
import StatusCard from './partial/StatusCard'
import { Chart as ChartJS, ArcElement, Tooltip, Legend, registerables} from "chart.js";
import ChangePassword from './partial/ChangePassword'
import { useAllContactQuery, useUpdateContactApiMutation } from '../../redux/API/ContactApi'
import toast, { Toaster } from 'react-hot-toast'
ChartJS.register(ArcElement, Tooltip, Legend, ...registerables);
const Dashboard = () => {
const [newClass, setNewClass] = useState("")
const [newSidebarClass, setNewSidebarClass] = useState("")
const [showPass, setShowPass] = useState(false)
 const [status, setStatus] = useState({})
 const [contactData, setContactData] = useState([])
const {data} = useAllContactQuery()
const [postData] = useUpdateContactApiMutation()
const handleToggle = () => {
  if (newClass === "") {
    setNewClass("main-active");
    } else {
      setNewClass("");
      }
      if(newSidebarClass === ""){
        setNewSidebarClass("closed");
      }
      else{
        setNewSidebarClass("");
      }
}

useEffect(() => {
  if (data) {
    const initialStatuses = {};
    data?.data?.forEach((item) => {
      initialStatuses[item.status] = item.status;
    });
    setStatus(initialStatuses);
  }
}, [data]);

const handleStatusChange = (status, newStatus, id) => {
  setStatus((prevStatuses) => ({
    ...prevStatuses,
    [status]: newStatus,
  }));
  postData({id: id, data: {status: newStatus}}).then((res) => {
    if(res?.data?.success){
      toast.success("Status Updated Successfully")
    }
    else{
      toast.error("Status Update Failedm Please try again")
    }
  })
};


  return (
    <>
    <Toaster position='top-right'/>
    <Sidebar
    newSidebarClass={newSidebarClass}
    />
    <div className={`main-context ${newClass}`}>
      <Header
      handleToggle={handleToggle}
      setShowPass={setShowPass}
      setNewSidebarClass={setNewSidebarClass}
      />
      <div className="admin-dashboard p-4">
      <div aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">Dashboard</li>
  </ol>
</div>

<div class="row gy-3">
    <div className='col-12'>

    <div className=" card p-4">
           
           <div className="table-wrapper w-100  overflow-x-auto ">
             <table className="table table-bordered ">
               <thead>
                 <tr>
                   <th scope="col">#</th>
                   <th scope="col">Name</th>
                   <th scope="col">Email</th>
                   <th scope="col">Phone</th>
                   <th scope="col">Message</th>
                   <th scope="col">Status</th>
                 </tr>
               </thead>
               <tbody>
                {
                 data && data?.data?.map((item, index) => (
                  <tr>
                  <td>{index+1}</td>
                  <td>{item?.name}</td>
                  <td>{item?.email}</td>
                  <td>{item?.phone}</td>
                  <td>{item?.message}</td>
                  <td>
                    <select name="status" id="status" 
                    value={status[item.status] || ""}
                    onChange={(e) => handleStatusChange(item.status, e.target.value, item?._id)}
                    className="border border-2 border-50-black"
                    >
                      <option value="new">New</option>
                      <option value="contacted">Contacted</option>
                      <option value="closed">Closed</option>
                      <option value="lost">Lost</option>
                      <option value="won">Won</option>
                      <option value="follow-up">Follow-Up</option>
                    </select>
                  </td>
              </tr>
                 ))
                }
               </tbody>
             </table>
           </div>
           
         </div>
    </div>
  </div>
 
      </div>
    </div>
    {
      showPass && (
        <ChangePassword
        setShowPass={setShowPass}
        />
      )
    }
    </>
  )
}

export default Dashboard